import "./IconStatement.scss";
import { ReactComponent as StatementIcon } from "./svg/statement.svg";

type Props = {
  color?: "black" | "blue";
};

export const IconStatement = (props: Props) => {
  const { color = "black" } = props;
  return (
    <span className={`IconStatement IconStatement${color}`}>
      <StatementIcon />
    </span>
  );
};
